<template>
  <div class="layout" :class="classObj">
    <Header />
    <el-container class="container">
      <Sidebar :base-path="basePath" class="sidebar-container" />
      <el-main class="main-content">
        <div class="main-content-inner">
          <el-breadcrumb v-if="fullPath !== '/index'" class="breadcrumb" separator-class="el-icon-caret-right">
            <el-breadcrumb-item v-for="item in breadcrumbList" :key="item.name" :to="item.path?{ path: item.path }:''">
              {{ item.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
          <router-view class="router-view" />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Header from './header.vue';
import Sidebar from './sidebar';
import { mapState } from 'vuex';

export default {
  components: {
    Header, Sidebar,
  },
  data() {
    return {
      basePath: '',
      fullPath: '',
      breadcrumbList: [],
    };
  },
  computed: {
    ...mapState('permission', [
      'routes',
    ]),
    ...mapState('app', [
      'sidebar',
      'device',
    ]),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
      };
    },
  },
  watch: {
    '$route': {
      handler() {
        this.handleRouteChange();
      },
    },
  },
  mounted() {
    this.handleRouteChange();
  },
  methods: {
    handleRouteChange() {
      this.breadcrumbList = [];
      this.basePath = this.$route.matched[0].path;
      this.fullPath = this.$route.fullPath;
      const array = this.$route.matched.slice(2);

      array.forEach(item => {
        if ((item.meta && item.meta.title) || item.name) {
          if (item.meta && item.meta.propName) {
            // this.breadcrumbList.push({ name: item.meta.propName, path: item.meta.activeMenu })
            this.breadcrumbList.push({ name: item.meta.propName });
          }
          // this.breadcrumbList.push({name: (item.meta && item.meta.title) || item.name, path: item.path});
          this.breadcrumbList.push({ name: (item.meta && item.meta.title) || item.name });
        }
      });
    },
  },

};
</script>

<style scoped lang="less">
.layout {
  min-width: 1024px;
}

.container {
  padding-top: 66px;
  height: 100%;
  .main-content {
    width: 100vw;
    height: 100vh;
    background: #f4f4f4;
    padding: 0 10px;
  }
  .side-menu {
    overflow-x: hidden;
    overflow-y: auto;
    background: #000000;
    color: #fff;
    height: 100%;
  }
  .main-content-inner {
    min-height: 100%;
    overflow: hidden;
    margin-left: 250px;
    transition: margin-left 0.28s;
    .router-view {
      padding: 16px;
    }
    .breadcrumb {
      padding-left: 20px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      margin-top: 30px;
    }
  }
  .sidebar-container {
    transition: width 0.28s;
    width: 250px !important;
    background-color: #000000;
    height: calc(100vh - 66px);
    position: fixed;
    font-size: 0px;
    top: 66px;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
  }
}
/deep/.el-breadcrumb__item {
  &:last-child {
    .el-breadcrumb__inner {
      font-weight: 700;
      text-decoration: none;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      color: #303133;
    }
  }
}
</style>
<style lang="less">
#app .hideSidebar {
  .sidebar-container {
    width: 54px !important;
  }
  .main-content-inner {
    margin-left: 54px;
  }
  .el-menu--collapse {
    .el-submenu {
      > .el-submenu__title {
        > span {
          height: 0;
          width: 0;
          overflow: hidden;
          visibility: hidden;
          display: inline-block;
        }
      }
    }
  }
  .el-submenu {
    > .el-submenu__title {
      .el-submenu__icon-arrow {
        display: none;
      }
    }
  }
}
</style>
